import { createStore, Middleware } from 'redux';

import { rootReducer } from './reducers';
import { AppState, INITIAL_APP_STATE } from './state';
import { API, createAPI } from './backend';
import { History } from 'history';
import { domHistory } from '@hum/common';
import { client } from '@hum/common/src/api/client';

export type CreateAppStoreProps = {
  api: API;
  history: History;
  initialState?: Partial<AppState>;
  middleware?: Middleware[];
};

export const createAppStore = ({ initialState = {} }: CreateAppStoreProps) => {
  const store = createStore(rootReducer, {
    ...INITIAL_APP_STATE,
    ...initialState,
  });

  return store;
};

// TODO: delete me, this is legacy code and we shouldn't have globals, but this
// is necessary for things like `confirm`, `fail`, and `succeed`
export const storeApi = createAPI({
  client,
});

export const reduxStore = createAppStore({
  api: storeApi,
  history: domHistory,
});
